
<title>ProjectGigaton</title>
 <div [ngClass]="'header'">
  <mat-toolbar color="primary" *ngIf="isPeopleRouteActive() || isCommoditiesRouteActive()">
    <span>
      <img class="walm-logo" src="assets/images/WalmartSustainability_Logo_LARGE-03.png" alt="logo" />
    </span>
    <span></span>
  </mat-toolbar>

    <img *ngIf="!isPeopleRouteActive()" src="../../../assets/images/project-gigatonlogo.png" alt="gigaton_logo"/>
    <div class="right login-user-div">


    </div>
</div>

